import { ApiHelper } from "shared/helpers/api";
import { getAdPlatformURL, ROUTES } from "shared/api/urls";
import { IHeadersObject } from "global";

export const getLandingpageData = (headers: IHeadersObject, pageName: string): Promise<object> => {
    const url = `${getAdPlatformURL(ROUTES.AD_PLATFORM_API)}?page_type=${pageName}&page_section=*`;

    return ApiHelper(url, { headers }).then((response: Response) => {
        const data = response.json();
        return data;
    });
};
